import { Grid, Row, Col, Table, Button } from "react-bootstrap";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import StoreExternalTender from "./StoreExternalTender";
import { StyleSheet, css } from "aphrodite";

const styles = StyleSheet.create({
    marginTop: {
        marginTop: 20,
    },
});

const strings = {
    posTenderName: "POS Tender Name",
    accountingNames: "Accounting Name(s) & Split",
    sort: "Sort",
    edit: "Edit",
    delete: "Delete",
    externalTenders: "External Tenders",
    add: "Add External Tender"
}

export default class StorePosSettingsTab extends PureComponent {
    static propTypes = {
        tenders: PropTypes.array.isRequired,
        onAdd: PropTypes.func.isRequired,
        onEdit: PropTypes.func.isRequired,
        onDelete: PropTypes.func.isRequired,
        onReorder: PropTypes.func.isRequired,
        loading: PropTypes.bool.isRequired,
    };

    _onAddClick = () => this.props.onAdd();

    render() {
        const tenders = this.props.tenders
        return (
            <Grid>
                <Row className={css(styles.marginTop)} bsClass="m-t">
                    <Col md={9}>
                        <h4>{strings.externalTenders}</h4>
                    </Col>
                    <Col md={3}>
                        <Button bsStyle="primary" onClick={this._onAddClick} disabled={this.props.loading}>
                            {strings.add}
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col className={css(styles.marginTop)} md={12}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>{strings.posTenderName}</th>
                                    <th>{strings.accountingNames}</th>
                                    <th>{strings.sort}</th>
                                    <th>{strings.edit}</th>
                                    <th>{strings.delete}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tenders.map((t, i) => (
                                    <StoreExternalTender
                                        key={`${t.id}`}
                                        index={i}
                                        numTenders={tenders.length}
                                        tender={t}
                                        onEdit={this.props.onEdit}
                                        onDelete={this.props.onDelete}
                                        onReorder={this.props.onReorder}
                                        loading={this.props.loading}
                                    />
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Grid>
        );
    }
}
